export const planRefName = 'planRef';

export const planRefProjection = `{
  _id,
  highlight,
  name,
  priceDescription,
  hideFeatures,
  showFeatures,
  CTAButton,
  summaryList,
  description,
  price,
  tagline,
  features[] {
    _key,
    featureType,
    feature -> {
      _id,
      prefLabel,
      definition,
    }
  }
}`;

export const planRefQuery = groq`*[_id == $_id && _type == "plan"][0] ${planRefProjection}`;
